<template>
  <div class="row search-referens">
    <div class="col-xl-7 col-lg-7 col-md-12 search-referens-popap-father">


      <!-- образец оформления скаченного файла в инпуте -->
      <!-- обертка .search-file-new-wrap нужна только для демонстрации -->
      <div v-if="getFile" class="search-file-new-wrap">
        <div class="search-file-new">
          <span class="file-name">{{ getFile.name }}</span>
          <button @click="fileClear" class="remove-file-new">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 8L8 16" stroke="#FBE9EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              </path>
              <path d="M16 16L8 8" stroke="#FBE9EB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              </path>
            </svg>
          </button>
        </div>
      </div>


      <div class="input-group">
        <input
          type="text"
          class="form-control input-conditions placeholderFull"
          :class="autocompleteLoading ? 'loading' : ''"
          :disabled="getFile"
          :value="getQuery"
          @input="autocompleteSearch($event.target.value)"
          @change="searchTextChanged"
          @keypress.enter="search"
          :placeholder="!getFile ? 'Поиск по референсам, описанию и ключевым словам' : ''">
        <reset-button v-if="getQuery !== ''" @click="autocompleteClear" class="catalog__input-btn-reset" />
        <span class="input-group-btn">
          <button @click="search" class="btn btn-light btn-default" type="button">Поиск</button>
        </span>
      </div>

      <div v-if="autocomplete.length" class="popaps-item popaps-item-ab">
        <table class="search-popap popap__content">
          <tr @click="selectAutocomplete(item)" v-for="(item, index) in autocomplete" :key="index">
            <td v-html="highlight(item.reference)" />
            <td v-html="highlight(item.description)" />
          </tr>
        </table>
      </div>
    </div>
    <div class="col-xl-3 col-lg-3 col-md-12 popap-ref-parent">
      <div>
        <button @click="toggleFileBox" class="search-referens-btn">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 16L5 19H19V16" stroke="#00AC86" stroke-width="2" />
            <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
              stroke-width="2" stroke-linecap="square" />
            <line x1="12" y1="14" x2="12" y2="4" stroke="#00AC86" stroke-width="2" />
          </svg>
          Поиск по списку
        </button>
      </div>

      <div v-if="fileBox" class="popaps-item popaps-item-ab">
        <div class="popap__content popap-import">
          <div class="popap__content-header">
            <p class="popap-import__content-text">
              Загрузите список референсов в формате .csv, .txt, .xlsx
            </p>
            <div @click="toggleFileBox" class="popap__btn-close" data-popaps="close">
              <i><img src="/img/ic_close_chip.svg" alt=""></i>
            </div>
          </div>
          <form class="catalog__catalog-file-form">
            <div class="input-group">
              <input id="search-file" ref="file" @change="fileUpload" accept=".csv,.txt,.xlsx" type="file">
              <label for="search-file" class="custom-file-label" data-btn-text="Выбрать файл">
                <span class="input-placeholder">Выберите файл</span>
              </label>
            </div>
          </form>

          <p class="popap-import__content-ask">
            <a class="btn collapsed" role="button" @click="toggleFileHelpBox" href="javascript:void(0);">
              <span class="popap-import__content-ask-1">
                <template v-if="!fileHelpBox">Справка (?)</template>
                <template v-else>Свернуть (?)</template>
              </span>
            </a>
          </p>

          <hr v-if="fileHelpBox" class="popap-import__content-hr">

          <div v-if="fileHelpBox" class="popap-import__content-body">
            <h4 class="popap-import__content-ask-title">Справка</h4>
            <p class="popap-import__content-ask-text">Сервис поддерживает загрузку до 1000 записей референсов. Загрузка данных для поиска можно загрузить либо в формате *.txt, либо в *.csv.</p>
            <h4 class="popap-import__content-ask-title">Загрузка файлов в CSV</h4>
            <div class="popap-import__content-ask-text">
              <p>1) Сохраните список референсов через Excel в формате .csv (Excel→Сохранить как→CSV
                (разделители - запятые). Обратите внимание, что в файле должен быть только список
                референсов (лишние данные нужно удалить).</p>
              <p>2) Нажмите кнопку "Загрузить", после в строке поиска "Найти".</p>
            </div>
            <h4 class="popap-import__content-ask-title">Загрузка файлов в TXT</h4>
            <div class="popap-import__content-ask-text">
              <p>1) Подготовьте файл в формате *.txt (каждое новое значение с новой строки, через
                Enter).
              </p>
              <p>2) Нажмите кнопку "Загрузить", после в строке поиска "Найти".</p>
            </div>
            <h4 class="popap-import__content-ask-title">Загрузка файлов в XLSX</h4>
            1) <a href="/catalog/template.xlsx" class="popap-import__content-ask-btn linkGreenConditions">Скачать образец</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_QUERY, SEARCH, SET_FILE } from '@/store/actions/search'
import debounce from 'lodash/debounce'
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'search-bar',
  data: () => ({
    fileBox: false,
    fileHelpBox: false,
    autocomplete: [],
    autocompleteLoading: false,
    axiosSource: {
      autocomplete: null,
      search: null
    },
    autocompleteSearchDebounce: debounce(function () {
      if (this.getQuery.length >= 3) {
        this.axiosSource.autocomplete = axios.CancelToken.source()
        this.$api.catalog.autocomplete(this.getQuery, { cancelToken: this.axiosSource.autocomplete.token }).then((response) => {
          this.autocomplete = response.data
          this.axiosSource.autocomplete = null
        }).finally(() => { this.autocompleteLoading = false })
      } else {
        this.autocompleteLoading = false
      }
    }, process.env.VUE_APP_DEBOUNCE_TIME)
  }),
  computed: {
    ...mapGetters(['getQuery', 'getFile'])
  },
  methods: {
    searchTextChanged (event) {
      if (event.target.value.length && this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Запрос в поисковой строке',
          action: 'Текст',
          label: event.target.value
        })
      }
    },
    search () {
      if (this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Клик по кнопке',
          action: 'Поиск'
        })
      }
      this.autocompleteCancel()
      this.autocomplete = []
      this.autocompleteSearchDebounce.cancel()
      const { $router: router } = this
      this.$store.dispatch(SEARCH, { router })
    },
    autocompleteCancel () {
      this.autocompleteLoading = false
      if (this.axiosSource.autocomplete) {
        this.axiosSource.autocomplete.cancel('Operation canceled due to new request.')
        this.axiosSource.autocomplete = null
      }
    },
    autocompleteSearch (query) {
      this.$store.dispatch(SET_QUERY, query)
      this.autocompleteCancel()
      this.autocomplete = []
      this.autocompleteLoading = this.getQuery.length >= 3
      this.autocompleteSearchDebounce()
    },
    selectAutocomplete (product) {
      window.location.href = product.url
    },
    toggleFileBox () {
      this.fileBox = !this.fileBox
      if (!this.fileBox) {
        this.fileHelpBox = false
      } else if (this.$gtm) {
        this.$gtm.trackEvent({
          event: 'UA event',
          category: 'Клик по кнопке',
          action: 'Поиск по списку'
        })
      }
      if (this.autocomplete.length) {
        this.autocomplete = []
      }
    },
    toggleFileHelpBox () {
      this.fileHelpBox = !this.fileHelpBox
    },
    autocompleteClear () {
      this.autocomplete = []
      this.$store.dispatch(SET_QUERY, '').then(() => {
        this.$store.dispatch(SEARCH)
      })
    },
    fileClear () {
      this.$store.dispatch(SET_FILE, null)
    },
    fileUpload () {
      const file = this.$refs.file.files[0]
      if (file) {
        if (this.$gtm) {
          this.$gtm.trackEvent({
            event: 'UA event',
            category: 'Запрос в поисковой строке',
            action: 'Файл',
            label: file.name
          })
        }
        this.$store.dispatch(SET_FILE, file)
        this.toggleFileBox()
      }
      this.$refs.file.value = null
    },
    highlight (text) {
      const index = text.toLowerCase().indexOf(this.getQuery.trim().toLowerCase())
      if (index >= 0) { 
        return `${text.substring(0, index)}<span>${text.substring(index, index + this.getQuery.length)}</span>${text.substring(index + this.getQuery.length)}`
      }
      return text
    }
  }
}
</script>